// extracted by mini-css-extract-plugin
export default {"rounded-gif":"Gif_rounded-gif__H1pAT"};